'use strict';

/* eslint-disable no-undef */

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('app_custom_mufe/product/quickView'));
    processInclude(require('./search/filterSettings'));
});

$(window).on('load', () => {
    processInclude(require('./search/ratings').initBazaarVoice());
});